import cloneDeep from 'lodash/cloneDeep'
import { PiniaPluginContext } from 'pinia'

// based on:
// https://stackoverflow.com/questions/71690883/pinia-reset-alternative-when-using-setup-syntax/71760032#71760032
// https://dev.to/the_one/pinia-how-to-reset-stores-created-with-functionsetup-syntax-1b74

export default function resetStore({ store }: PiniaPluginContext) {
  // Save the initial state by cloning the current $state
  const initialState = cloneDeep(store.$state)

  // Add $reset method manually to the store instance
  store.$reset = () => {
    store.$patch(cloneDeep(initialState))
  }
}
